let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hP5UZ")).then(() => parcelRequire('7UVx9'));